import styled from 'styled-components';
import { colors, fontSize, media, spacer } from 'settings/style';
import { MetaRow, ProfileCard } from 'containers/account/profile/profile.styled';

export const LoginNoticeCard = styled(ProfileCard)`
  text-align: center;
  padding: ${spacer.xl} ${spacer.lg};

  p {
    margin: 0 0 ${spacer.lg};
    color: ${colors.gray700};
    line-height: 1.6;
  }
`;

export const PublicProfileContent = styled.div`
  padding-top: 0.5rem;
`;

export const ReferenceMetaRow = styled(MetaRow)`
  ${media.md`
    flex-direction: column;
    gap: ${spacer.md};
  `}
`;

export const ReferenceEmailItem = styled.div`
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  color: ${colors.gray700};
  font-size: ${fontSize.md};

  ${media.md`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  `}
`;

export const ReferenceEmailLabel = styled.span`
  flex-shrink: 0;
`;

export const ReferenceEmailValue = styled.span`
  ${media.md`
    word-break: break-all;
    width: 100%;
  `}
`;
